<template>
  <div id="main-wrapper">
    <NavbarDark :transparent="false" />

    <!-- ============================ Hero Banner  ================================== -->
    <div class="hero-banner-modern">
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-9 col-lg-10 col-md-12 col-sm-12">
            <div class="hero-content-container">
              <div class="hero-text-content">
                <h1>Your next home is just one search away.</h1>
                <p>Discover beautiful homes in Greater Moncton Area.</p>
              </div>
              <div class="glass-search-bar">
                <div class="search-options">
                  <div class="form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="typrent"
                      name="typeprt"
                      value="rent"
                      v-model="selectedType"
                      checked
                    />
                    <label class="form-check-label" for="typrent">Rent</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="typbuy"
                      name="typeprt"
                      value="buy"
                      v-model="selectedType"
                    />
                    <label class="form-check-label" for="typbuy">Buy</label>
                  </div>
                </div>
                <div class="search-input">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search for a location"
                    v-model="selectedCity"
                  />
                </div>
                <div class="search-button">
                  <button
                    @click="filterProperties"
                    type="button"
                    class="btn btn-primary"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================ Hero Banner End ================================== -->

    <!-- <section>
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <div class="sec-heading mb-4 mss">
                            <h2>Choose Property Type</h2>
                            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                        </div>
                    </div>
                </div>
                <PropertyType/>
            </div>
        </section> -->
    <div class="clearfix"></div>

    <section class="gray-simple py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-9 col-md-11">
            <h2 class="text-center mb-3">Rental Properties in Greater Moncton Area</h2>
            <p>
              Looking for <strong>rental properties in Moncton</strong>?
              99Properties.ca helps renters find apartments, houses, condos, and
              basement units across all major neighbourhoods including Downtown,
              Dieppe, Riverview, and the growing North End. Whether you are
              searching for an affordable apartment or a family-friendly home,
              our platform makes it easy to browse updated listings and contact
              verified landlords.
            </p>

            <p>
              Moncton’s rental market continues to grow, offering options for
              every budget—from modern one-bedroom apartments to large family
              homes. Use our search filters to explore the newest
              <strong>Moncton rentals</strong>, check availability, compare
              prices, and find a home that fits your needs. Start your search
              below or browse our full list of
              <router-link to="/list-layout-new-3"
               class="text-primary" ><strong>rental properties in Greater Moncton</strong></router-link
              >.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="gray-simple">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-6 col-lg-7 col-md-10 text-center">
            <div class="sec-heading mss">
              <h2>Search for rental home</h2>
              <p></p>
            </div>
          </div>
        </div>
        <!-- Show spinner while loading -->
        <div v-if="isLoading" class="text-center my-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <GridOne
          v-else-if="filteredPropertyData.length > 0"
          :propertyData="filteredPropertyData"
        />
        <!-- If there are no properties, show a message -->
        <div v-else class="text-center my-5">
          <h4>No Properties Found</h4>
          <p class="text-muted">Please refine your search criteria.</p>
        </div>
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
            <router-link
              to="/list-layout-new-3"
              class="btn btn-primary px-md-5 rounded"
              >Browse More Properties</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <!-- <section>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                        <div class="sec-heading center">
                            <h2>Find Best Locations</h2>
                            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores</p>
                        </div>
                    </div>
                </div>
                <BestLocation/>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
                        <router-link to="/listings-list-with-sidebar" class="btn btn-primary px-md-5 rounded">Browse More Locations</router-link>
                    </div>
                </div>
            </div>
        </section> -->
    <hr class="opacity-25" />

    <!-- ===== Trade Services Section ===== -->
    <section class="trade-services-section">
      <div class="container">
        <div class="row justify-content-center mb-2">
          <div class="col-xl-6 col-lg-7 col-md-10 text-center">
            <div class="sec-heading mss">
              <h2>Property Trade Services</h2>
              <p>Licensed professionals for all your maintenance and improvement needs.</p>
            </div>
          </div>
        </div>

        <!-- Carousel -->
        <div class="trades-carousel-wrapper">
          <button class="carousel-nav carousel-prev" @click="scrollCarousel(-1)" aria-label="Previous">
            <i class="fa-solid fa-chevron-left"></i>
          </button>

          <div class="trades-carousel" ref="carouselRef">
            <div
              class="trade-card-slide"
              v-for="trade in trades"
              :key="trade.name"
              @click="goToService(trade.name)"
            >
              <div class="trade-card-header" :class="trade.colorClass">
                <i :class="trade.icon"></i>
              </div>
              <div class="trade-card-body">
                <h5 class="trade-card-title">{{ trade.name }}</h5>
                <p class="trade-card-desc">{{ trade.description }}</p>
                <span class="trade-card-cta">
                  Book Now <i class="fa-solid fa-arrow-right ms-1"></i>
                </span>
              </div>
            </div>
          </div>

          <button class="carousel-nav carousel-next" @click="scrollCarousel(1)" aria-label="Next">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>

        <div class="row align-items-center justify-content-center mt-4">
          <div class="col-12 text-center">
            <router-link to="/trade-services" class="btn btn-primary px-md-5 rounded">
              Browse All Services
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- ===== Trade Services Section End ===== -->

    <hr class="opacity-25" />

    <!-- <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-md-10 text-center">
            <div class="sec-heading center">
              <h2>Featured Property For Sale</h2>
              <p>your next home is waiting !!!</p>
            </div>
          </div>
        </div>
        <FeatureProperty :border="true" />
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-4">
            <router-link
              to="/listings-list-with-sidebar"
              class="btn btn-primary px-lg-5 rounded"
              >Browse More Properties</router-link
            >
          </div>
        </div>
      </div>
    </section> -->

    <!-- <CtaTwo /> -->

    <!-- <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-md-10 text-center">
            <div class="sec-heading center">
              <h2>Explore Featured Agents</h2>
              <p>
                Our agents are here to help you find your dream home. They are
                experienced, knowledgeable, and dedicated to providing you with great service
              </p>
            </div>
          </div>
        </div>
        <TeamOne />
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5">
            <RouterLink
              to="/listings-list-with-sidebar"
              class="btn btn-primary px-lg-5 rounded"
              >Explore More Agents</RouterLink
            >
          </div>
        </div>
      </div>
    </section> -->
    <div class="clearfix"></div>

    <section class="gray-bg">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-md-10 text-center">
            <div class="sec-heading center">
              <h2>Reviews by Customers</h2>
              <p>
                Hear directly from our valued clients! Their honest feedback and
                real-life experiences showcase the quality and reliability of
                our services. Read what people are saying and see why 99
                Property Management is their trusted choice.
              </p>
            </div>
          </div>
        </div>
        <ClientOne />
      </div>
    </section>

    <!-- <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7 col-md-10 text-center">
            <div class="sec-heading center">
              <h2>Latest Updates By Resido</h2>
              <p>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                blanditiis praesentium voluptatum deleniti atque corrupti quos
                dolores
              </p>
            </div>
          </div>
        </div>
         <BlogOne /> 
      </div>
    </section> -->

    <!-- <SubscribeLight/> -->
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
//import city from "@/assets/img/side-city-1.png";
// import BlogOne from "@/components/blog-one.vue";
import ClientOne from "@/components/client-one.vue";
// import CtaTwo from "@/components/cta-two.vue";
import FooterDark from "@/components/footer/footer-dark.vue";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import GridOne from "@/components/property/grid-one.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
// import TeamOne from "@/components/team-one.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const router = useRouter();

const carouselRef = ref(null);

const trades = [
  {
    name: "Electrical",
    icon: "fa-solid fa-bolt",
    colorClass: "trade-electrical",
    description: "Panel upgrades, outlets, wiring inspections & lighting — fully licensed and up to code.",
  },
  {
    name: "Plumbing",
    icon: "fa-solid fa-faucet-drip",
    colorClass: "trade-plumbing",
    description: "Leaky pipes, drain clogs, water heaters & fixture replacements — fast certified response.",
  },
  {
    name: "Lawn Care",
    icon: "fa-solid fa-seedling",
    colorClass: "trade-lawn",
    description: "Lawn mowing, grass trimming, edge & fence lines, basic yard cleaning, and light debris removal such as leaves and grass clippings.",
  },
  {
    name: "Handyman",
    icon: "fa-solid fa-screwdriver-wrench",
    colorClass: "trade-handyman",
    description: "Drywall, painting, door & window repairs — one call covers a wide range of tasks.",
  },
  {
    name: "HVAC",
    icon: "fa-solid fa-wind",
    colorClass: "trade-hvac",
    description: "Heating, cooling & ventilation — installation, maintenance & emergency repairs.",
  },
  {
    name: "Cleaning",
    icon: "fa-solid fa-soap",
    colorClass: "trade-cleaning",
    description: "Deep cleans, move-in/move-out, and recurring maintenance cleans for any property.",
  },
  {
    name: "Painting",
    icon: "fa-solid fa-paint-roller",
    colorClass: "trade-painting",
    description: "Interior & exterior painting with quality finishes — on time, every time.",
  },
  {
    name: "Mini Split Cleaning",
    icon: "fa-solid fa-snowflake",
    colorClass: "trade-minisplit",
    description: "Filter, coil & drainage cleaning for ductless mini splits — better air, better efficiency.",
  },
  {
    name: "Duct Cleaning",
    icon: "fa-solid fa-filter",
    colorClass: "trade-duct",
    description: "Remove dust & allergens from your ductwork to improve air quality and cut energy costs.",
  },
  {
    name: "Driveway Seal",
    icon: "fa-solid fa-road",
    colorClass: "trade-driveway",
    description: "Asphalt & concrete crack sealing, resurfacing & sealcoating to protect your driveway.",
  },
  {
    name: "Roofing",
    icon: "fa-solid fa-house-chimney",
    colorClass: "trade-roofing",
    description: "Roof repairs, storm damage repair, leak detection and repairs, and full roof inspections to protect your property.",
  },
];

const goToService = (service) => {
  router.push({ path: "/trade-request", query: { service } });
};

const scrollCarousel = (direction) => {
  if (!carouselRef.value) return;
  const card = carouselRef.value.querySelector(".trade-card-slide");
  const cardWidth = card ? card.offsetWidth + 24 : 300; // 24 = gap
  carouselRef.value.scrollBy({ left: direction * cardWidth, behavior: "smooth" });
};

const initialized = ref(false);
const propertyData = ref([]); // All property data
const filteredPropertyData = ref([]); // Filtered property data
const store = useStore();
const selectedType = ref(""); // Selected type (buy/rent)
const selectedCity = ref(""); // Selected city
const isLoading = ref(true); // Spinner state

// Load properties on mount
onMounted(async () => {
  if (!initialized.value) {
    initialized.value = true;
    console.log("In mounted of index-ten.vue");
    await store.dispatch("properties/loadPropertiesfirebaseAdmin");
    propertyData.value = store.getters["properties/properties"];
    filteredPropertyData.value = propertyData.value; // Initialize filtered data
    isLoading.value = false; // Stop spinner after data is loaded
  }
});

// Filter properties based on selected type and city
const filterProperties = () => {
  console.log("Filter properties function called");
  isLoading.value = true; // Show spinner while filtering

  filteredPropertyData.value = propertyData.value.filter((item) => {
    // Check if the selected type matches
    const matchesType =
      !selectedType.value || // If no type is selected, include all
      (selectedType.value === "buy" && item.tag2 === "For Sell") ||
      (selectedType.value === "rent" && item.tag2 === "For Rent");

    // Check if the selected city matches
    const matchesCity =
      !selectedCity.value || // If no city is selected, include all
      item.city.toLowerCase().includes(selectedCity.value.toLowerCase());

    // Include the item only if it matches both type and city
    return matchesType && matchesCity;
  });

  isLoading.value = false; // Stop spinner after filtering
};

// // Watch for changes in selectedType and selectedCity
// watch([selectedType, selectedCity], () => {
//   filterProperties(); // Re-run the filter whenever the search parameters change
// });
</script>

<style scoped>
/* ── Trade Services Carousel ── */
.trade-services-section {
  padding: 4rem 0;
  background: #f8fafd;
}

.trades-carousel-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.trades-carousel {
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  padding: 1rem 0.25rem 1.5rem;
  flex: 1;
}

/* Hide scrollbar but keep scroll functionality */
.trades-carousel::-webkit-scrollbar { display: none; }
.trades-carousel { -ms-overflow-style: none; scrollbar-width: none; }

/* Carousel navigation arrows */
.carousel-nav {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid #dee2e6;
  background: #fff;
  color: #444;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 2;
}
.carousel-nav:hover {
  background: #0d6efd;
  border-color: #0d6efd;
  color: #fff;
  box-shadow: 0 4px 14px rgba(13,110,253,0.3);
}

/* Individual trade card */
.trade-card-slide {
  scroll-snap-align: start;
  flex: 0 0 calc(33.33% - 1rem);
  min-width: 240px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0,0,0,0.07);
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}
.trade-card-slide:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.13);
}

/* Gradient header with big icon */
.trade-card-header {
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2rem;
  color: #fff;
}

/* Card body */
.trade-card-body {
  padding: 1.25rem 1.4rem 1.4rem;
}
.trade-card-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a1a2e;
}
.trade-card-desc {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.55;
  margin-bottom: 1rem;
}
.trade-card-cta {
  font-size: 0.85rem;
  font-weight: 600;
  color: #0d6efd;
  transition: gap 0.2s;
}
.trade-card-slide:hover .trade-card-cta {
  text-decoration: underline;
}

/* Gradient colors */
.trade-electrical { background: linear-gradient(135deg, #f59e0b, #d97706); }
.trade-plumbing   { background: linear-gradient(135deg, #3b82f6, #1d4ed8); }
.trade-lawn       { background: linear-gradient(135deg, #22c55e, #15803d); }
.trade-handyman   { background: linear-gradient(135deg, #f97316, #c2410c); }
.trade-hvac       { background: linear-gradient(135deg, #06b6d4, #0e7490); }
.trade-cleaning   { background: linear-gradient(135deg, #a78bfa, #7c3aed); }
.trade-painting   { background: linear-gradient(135deg, #f472b6, #be185d); }
.trade-minisplit  { background: linear-gradient(135deg, #67e8f9, #0284c7); }
.trade-duct       { background: linear-gradient(135deg, #94a3b8, #475569); }
.trade-driveway   { background: linear-gradient(135deg, #78716c, #44403c); }
.trade-roofing    { background: linear-gradient(135deg, #ef4444, #991b1b); }

/* Responsive card widths */
@media (max-width: 991px) {
  .trade-card-slide { flex: 0 0 calc(50% - 0.75rem); }
}
@media (max-width: 575px) {
  .trade-card-slide { flex: 0 0 82%; }
  .carousel-nav { display: none; }
}

/* Main Banner Styling */
.hero-banner-modern {
  background: url("../../assets/img/bgimage.png?q=80&w=2070&auto=format&fit=crop")
    no-repeat center center;
  background-size: cover;
  padding: 12rem 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(10, 22, 39, 0.5); /* Dark blue overlay */
  z-index: 1;
}

.hero-banner-modern .container {
  position: relative;
  z-index: 2;
}

/* Content Wrapper */
.hero-content-container {
  text-align: center;
  background: none; /* Prevents global styles from adding a white background */
}

.hero-text-content h1 {
  color: #ffffff;
  font-size: 3.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.hero-text-content p {
  color: #e0e0e0;
  font-size: 1.25rem;
  margin-bottom: 2.5rem;
}

/* Glass Search Bar */
.glass-search-bar {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.25); /* Slightly more visible background */
  border-radius: 18px; /* Rounded corners from image */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  gap: 1.5rem;
}

.search-options {
  display: flex;
  gap: 1.5rem;
}

.search-input {
  flex-grow: 1;
}

.search-input .form-control {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #ffffff;
  font-size: 1rem;
  padding-left: 0;
}

.search-input .form-control::placeholder {
  color: #d1d1d1;
  opacity: 1;
}

/* Modern Radio Buttons */
.form-check-inline {
  display: flex;
  align-items: center;
  font-weight: 600;
  padding: 0;
  margin: 0;
}

.form-check-input {
  display: none !important;
}

.form-check-label {
  color: #ffffff !important; /* Use !important to override other styles */
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.form-check-label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color 0.2s;
}

.form-check-input:checked + .form-check-label::before {
  background-color: #074da3; /* Primary blue */
}

.form-check-input:checked + .form-check-label::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ffffff; /* White dot */
}
</style>
